import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import _ from 'lodash';
import { Encoding } from '../components/wizard-ui/types/types';

interface IssueState {
    holderPublicKey: string;
    signerPrivateKey: string;
    signerPublicKey: string;
    jsonValue: object;
    jsonEditorValue: object;
    vc: string;
    publicKeyEncoding: Encoding;
    privateKeyEncoding: Encoding;
    keyArray: string[];
    valueArray: string[];
    inputComponentList: number[];
}

const initialState: IssueState = {
    holderPublicKey: '938ec3f412be512d80b053a02f544a6facebd85f1eea23d7231a5b0278244f8f',
    signerPrivateKey: 'ed710c0f8812e360dafa4dd2888b7ff24d2401223daf961e7e78988a56fa24a4',
    signerPublicKey: '',
    jsonValue: {},
    jsonEditorValue: {
        id: _.uniqueId(),
        type: 'object',
        data_type: 'object',
        attribute: 'data',
        data: [
            {
                id: _.uniqueId(),
                type: 'object',
                data_type: 'array',
                data_options: { type: 'text', remove: true },
                attribute: '@context',
                add: true,
                data: [
                    {
                        id: _.uniqueId(),
                        type: 'text',
                        remove: true,
                        data: 'https://www.w3.org/2018/credentials/v1'
                    },
                    {
                        id: _.uniqueId(),
                        type: 'text',
                        remove: true,
                        data: 'https://cdn.zedeid.com/credentials/microrewards/v2.00/toolsdemo'
                        
                    }
                ]
            },
            {
                id: _.uniqueId(),
                type: 'object',
                data_type: 'text',
                attribute: 'id',
                data: [{ id: _.uniqueId(), type: 'text', data: 'http://localhost:8080/verify/1' }]
            },
            {
                id: _.uniqueId(),
                type: 'object',
                data_type: 'text',
                attribute: 'issuanceDate',
                data: [{ id: _.uniqueId(), type: 'text', data: new Date().toISOString() }]
            },
            {
                id: _.uniqueId(),
                type: 'object',
                data_type: 'array',
                attribute: 'type',
                data: [{ id: _.uniqueId(), type: 'text', data: 'VerifiableCredential' }]
            },
            {
                id: _.uniqueId(),
                type: 'object',
                data_type: 'text',
                attribute: 'issuer',
                data: [
                    {
                        id: _.uniqueId(),
                        type: 'text',
                        data: 'did:key:z6Mkoqgh9AppS2s28onvE4Qy9jwDBJ8ZqRdBtoWLSsRL57Jj'
                    }
                ]
            },
            {
                id: _.uniqueId(),
                type: 'object',
                data_type: 'object',
                data_options: {
                    type: 'object',
                    data: [{ type: 'text', data: '' }],
                    remove: true
                },
                attribute: 'credentialSubject',
                add: true,
                data: [
                    {
                        id: _.uniqueId(),
                        type: 'object',
                        data_type: 'text',
                        attribute: 'holder',
                        data: [
                            {
                                id: _.uniqueId(),
                                type: 'text',
                                data: 'did:key:z6MkpPGEr3D3cM6846kLRo1Wpe9kjFvu3Aey4fsZMVxCWdT4'
                            }
                        ]
                    },
                    {
                        id: _.uniqueId(),
                        type: 'object',
                        data_type: 'array',
                        attribute: 'type',
                        remove: true,
                        data: [
                            {
                                id: _.uniqueId(),
                                type: 'text',
                                data: 'SelectivelyDisclosableAttributes'
                            }
                        ]
                    },
                    {
                        id: _.uniqueId(),
                        type: 'object',
                        data_type: 'array',
                        attribute: 'customAttribute',
                        data_options: {
                            type: 'object',
                            data_type: 'object',
                            remove: true,
                            no_attribute: true,
                            data: [
                                {
                                    type: 'object',
                                    data_type: 'array',
                                    attribute: 'type',
                                    data: [{ type: 'text', data: 'NameValuePair' }]
                                },
                                {
                                    type: 'object',
                                    attribute: 'name',
                                    data: [{ type: 'text', data: '' }]
                                },
                                {
                                    type: 'object',
                                    attribute: 'value',
                                    data: [{ type: 'text', data: '' }]
                                }
                            ]
                        },
                        add: true,
                        remove: true,
                        data: [
                            {
                                id: _.uniqueId(),
                                type: 'object',
                                data_type: 'object',
                                remove: true,
                                no_attribute: true,
                                attribute: '',
                                data: [
                                    {
                                        type: 'object',
                                        data_type: 'array',
                                        attribute: 'type',
                                        data: [{ type: 'text', data: 'NameValuePair' }]
                                    },
                                    {
                                        type: 'object',
                                        attribute: 'name',
                                        data: [{ type: 'text', data: 'test name 1' }]
                                    },
                                    {
                                        type: 'object',
                                        attribute: 'value',
                                        data: [{ type: 'text', data: 'test value 1' }]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: _.uniqueId(),
                        type: 'object',
                        data_type: 'text',
                        attribute: 'demo_dob',
                        data: [
                            {
                                id: _.uniqueId(),
                                type: 'text',
                                data: '2010-10-30'
                            }
                        ]
                    },
                    {
                        id: _.uniqueId(),
                        type: 'object',
                        data_type: 'text',
                        attribute: 'demo_ssn',
                        data: [
                            {
                                id: _.uniqueId(),
                                type: 'text',
                                data: '1234567890'
                            }
                        ]
                    },
                    {
                        id: _.uniqueId(),
                        type: 'object',
                        data_type: 'text',
                        attribute: 'demo_status',
                        data: [
                            {
                                id: _.uniqueId(),
                                type: 'text',
                                data: 'single'
                            }
                        ]
                    },
                    {
                        id: _.uniqueId(),
                        type: 'object',
                        data_type: 'text',
                        attribute: 'demo_postcode',
                        data: [
                            {
                                id: _.uniqueId(),
                                type: 'text',
                                data: '046800'
                            }
                        ]
                    }                    
                ]
            }
        ]
    },
    vc: '',
    publicKeyEncoding: 'Hex',
    privateKeyEncoding: 'Hex',
    keyArray: [''],
    valueArray: [''],
    inputComponentList: [0]
};

export const issueSlice = createSlice({
    name: 'issue',
    initialState,
    reducers: {
        setHolderPublicKey: (state, action: PayloadAction<string>) => {
            state.holderPublicKey = action.payload;
        },
        setSignerPrivateKey: (state, action: PayloadAction<string>) => {
            state.signerPrivateKey = action.payload;
        },
        setSignerPublicKey: (state, action: PayloadAction<string>) => {
            state.signerPublicKey = action.payload;
        },
        setJsonValue: (state, action: PayloadAction<object>) => {
            state.jsonValue = action.payload;
        },
        setJsonEditorValue: (state, action: PayloadAction<object>) => {
            state.jsonEditorValue = action.payload;
        },
        setVC: (state, action: PayloadAction<string>) => {
            state.vc = action.payload;
        },
        setPublicKeyEncoding: (state, action: PayloadAction<Encoding>) => {
            state.publicKeyEncoding = action.payload;
        },
        setPrivateKeyEncoding: (state, action: PayloadAction<Encoding>) => {
            state.privateKeyEncoding = action.payload;
        },
        setKeyArray: (state, action: PayloadAction<string[]>) => {
            state.keyArray = action.payload;
        },
        setValueArray: (state, action: PayloadAction<string[]>) => {
            state.valueArray = action.payload;
        },
        setInputComponentList: (state, action: PayloadAction<number[]>) => {
            state.inputComponentList = action.payload;
        }
    }
});

export const {
    setHolderPublicKey,
    setSignerPrivateKey,
    setSignerPublicKey,
    setVC,
    setPublicKeyEncoding,
    setPrivateKeyEncoding,
    setJsonValue,
    setJsonEditorValue,
    setKeyArray,
    setValueArray,
    setInputComponentList
} = issueSlice.actions;

export const _holderPublicKey = (state: RootState) => state.issue.holderPublicKey;
export const _signerPrivateKey = (state: RootState) => state.issue.signerPrivateKey;
export const _signerPublicKey = (state: RootState) => state.issue.signerPublicKey;
export const _jsonValue = (state: RootState) => state.issue.jsonValue;
export const _jsonEditorValue = (state: RootState) => state.issue.jsonEditorValue;
export const _vc = (state: RootState) => state.issue.vc;
export const _publicKeyEncoding = (state: RootState) => state.issue.publicKeyEncoding;
export const _privateKeyEncoding = (state: RootState) => state.issue.privateKeyEncoding;
export const _keyArray = (state: RootState) => state.issue.keyArray;
export const _valueArray = (state: RootState) => state.issue.valueArray;
export const _inputComponentList = (state: RootState) => state.issue.inputComponentList;

export default issueSlice.reducer;
